import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const LanguageContext = createContext(null);

const STORAGE_KEY = "perla_lang";

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem(STORAGE_KEY) || "it");
  const [content, setContent] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api
      .get("/content")
      .then((r) => setContent(r.data || {}))
      .catch(() => setContent({}))
      .finally(() => setLoaded(true));
  }, []);

  const setLang = useCallback((next) => {
    setLangState(next);
    localStorage.setItem(STORAGE_KEY, next);
    document.documentElement.lang = next;
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (key, fallback = "") => {
      const entry = content[key];
      if (!entry) return fallback;
      return entry[lang] || entry.it || fallback;
    },
    [content, lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, content, loaded }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
